import { useModal, create, show } from "@ebay/nice-modal-react";
import { useMutation } from "@apollo/client";

import useTypedContext from "hooks/useTypedContext";
import FlashContext from "components/FlashMessages/FlashContext";
import DeleteConfirmationModal from "ds/components/DeleteConfirmationModal";

import { DELETE_BLUEPRINT_GROUP } from "./gql";
import { REFETCH_QUERIES_LIST } from "./constants";

type DeleteConfirmationProps = {
  name: string;
  id: string;
};

const DeleteConfirmation = create(function DeleteConfirmation({
  name,
  id,
}: DeleteConfirmationProps) {
  const { onError, reportSuccess } = useTypedContext(FlashContext);

  const modal = useModal();

  const [deleteTemplate, { loading, data }] = useMutation(DELETE_BLUEPRINT_GROUP, {
    refetchQueries: REFETCH_QUERIES_LIST,
    awaitRefetchQueries: true,
    variables: { id },
  });

  const handleDeleteTemplate = () => {
    deleteTemplate()
      .then(() => {
        reportSuccess({
          message: `Template "${name}" was successfully deleted`,
        });
        modal.resolve();
        modal.hide();
      })
      .catch(onError);
  };

  return (
    <DeleteConfirmationModal
      title="Delete template"
      name={name}
      onConfirm={handleDeleteTemplate}
      isLoading={loading}
      isDismissable={!loading && !data?.blueprintVersionedGroupDelete?.id}
    />
  );
});

export const showDeleteConfirmation = (props: DeleteConfirmationProps) =>
  show(DeleteConfirmation, props);
